export default __webpack_public_path__ + "static/media/s3_male.fe5ec0c4.wav";